export default __webpack_public_path__ + "static/media/67167048c13cf2de31abfa047de91b87.svg";